export default {
	TEACHER: 'teacher',
	STUDENT: 'student',
}
